<template>
	<div>
		<a-card style="width: 1100px">
			<a-page-header title="添加商品" subTitle="打造你的小商铺~">
				<a-tag color="red">本平台暂不支持运费核算，只支持包邮，谨慎填写价格！</a-tag>
			</a-page-header>

			<a-steps type="navigation" v-model="current"
				style="marginBottom: '40px';boxShadow: '0px -1px 0 0 #e8e8e8 inset'">
				<!-- <a-step :status="zero" title="商品信息"><a-icon type="shopping" slot="icon" /></a-step>
				<a-step :status="one" title="商品促销"><a-icon type="rocket" slot="icon" /></a-step>
				<a-step :status="two" title="商品属性"><a-icon type="form" slot="icon" /></a-step> -->
				<a-step :status="zero" title="商品信息" :disabled="zeroDisabled"><a-icon type="shopping" slot="icon" /></a-step>
				<a-step :status="one" title="商品促销" :disabled="oneDisabled"><a-icon type="rocket" slot="icon" /></a-step>
				<a-step :status="two" title="商品属性" :disabled="twoDisabled"><a-icon type="form" slot="icon" /></a-step>
			</a-steps>
			<a-form-model ref="storeInfo" v-if="current == 0" :model="storeInfo" style="margin-top: 50px;"
				:label-col="{ span: 4 }" :wrapper-col="{ span: 14 }">
				<a-form-model-item label="商品名称" required><a-input :maxLength="150" v-model="storeInfo.name"
						placeholder="请输入商品名称!" /></a-form-model-item>
				<a-form-model-item label="商品分类" required>
					<a-select v-model="storeInfo.classify" placeholder="请输入商品分类!">
						<a-select-option :key="index" v-for="(item, index) in typeList" :value="item.id">{{ item.name
						}}</a-select-option>
					</a-select>
					<a-alert v-if="storeInfo.classify != undefined && storeInfo.classify.length > 0" message="请先添加商品分类"
						type="error" show-icon />
				</a-form-model-item>

				<!-- <a-form-model-item label="副标题" required><a-input v-model="storeInfo.subhead" placeholder="请输入副标题!" /></a-form-model-item> -->
				<!-- <a-form-model-item label="商品关键字"><a-input v-model="storeInfo.keyword" placeholder="请输入商品关键字!" /></a-form-model-item> -->
				<!-- <a-form-model-item label="商品介绍" required><a-input v-model="storeInfo.introduce" placeholder="请输入商品介绍!" type="textarea" /></a-form-model-item> -->
				<!-- <a-form-model-item label="商品货号" required><a-input v-model="storeInfo.productCode" placeholder="请输入商品货号!" /></a-form-model-item> -->
				<a-form-model-item label="排序">
					<a-input-number :min="0" :max="100" v-model="storeInfo.productSort" />
					<span class="ant-rate-text">数值越大越靠前（最大100）</span>
				</a-form-model-item>
				<a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
					<a-button type="primary" @click="onSubmit" :disabled="checkStoreInfo()">下一步，填写商铺促销</a-button>
				</a-form-model-item>
			</a-form-model>

			<a-form-model ref="storeMarket" v-if="current == 1" :model="storePromotion" style="margin-top: 35px;"
				:label-col="{ span: 4 }" :wrapper-col="{ span: 14 }">
				<!-- <a-form-model-item label="服务保证">
					<a-checkbox-group v-model="storePromotion.serve">
						<a-checkbox value="1" name="type">无忧退换</a-checkbox>
						<a-checkbox value="2" name="type">快速退款</a-checkbox>
						<a-checkbox value="3" name="type">免费包邮</a-checkbox>
					</a-checkbox-group>
				</a-form-model-item> -->
				<a-form-model-item label="商品上架"><a-switch v-model="storePromotion.putaway" /></a-form-model-item>
				<a-form-model-item label="线上交易">
					<a-switch v-model="storePromotion.onLinePay" disabled />
					<a-tag style="margin-left: 20px;" color="orange">交易方式为线上交易、线下交易</a-tag>
				</a-form-model-item>
				<a-form-model-item label="商品起批量">
					<a-input-number :min="0" v-model="storePromotion.minShop" />
					<span class="ant-rate-text"><a-tag style="margin-left: 20px;"
							color="orange">商品多少件起卖，为0则不限制</a-tag></span>
				</a-form-model-item>
				<!-- <a-form-model-item label="单次最大购买量">
					<a-input-number :min="0" v-model="storePromotion.maxShop" />
					<span class="ant-rate-text"><a-tag style="margin-left: 20px;" color="orange">商品多少件起卖，为0则不限制</a-tag></span>
				</a-form-model-item> -->
				<a-form-model-item label="商品推荐">
					<a-switch v-model="storePromotion.recommend" />
					<a-tag style="margin-left: 20px;" color="orange">推荐（将商品展示到帝全商城）</a-tag>
				</a-form-model-item>
				<!-- <a-form-model-item label="商品包邮">
					<a-switch v-model="storePromotion.postage" />
				</a-form-model-item> -->
				<!-- <a-form-model-item  v-if="!storePromotion.postage" label="商品运费" required>
					<a-input-number :min="0" v-model="storePromotion.freight" />&nbsp;&nbsp;元
				</a-form-model-item> -->
				<a-form-model-item v-if="adminPhone == '19924552520'" label="商品限购">
					<a-switch v-model="storePromotion.limit" />
					<a-tag style="margin-left: 20px;" color="orange">限购（一个用户只能购买一件）</a-tag>
				</a-form-model-item>
				<!-- <a-form-model-item v-if="storePromotion.recommend" label="商城分类" required>
					<a-tree-select
						style="width: 100%"
						:dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
						:treeData="treeData"
						placeholder="请选择分类"
						treeCheckStrictly
						v-model="storePromotion.mallClassify"
					>
						<span style="color: #08c" slot="title" slot-scope="{ key, value }" treeCheckStrictly>Child Node1 {{ value }}</span>
					</a-tree-select>
				</a-form-model-item> -->
				<a-form-model-item label="商城分类" v-if="storePromotion.recommend" required>
					<a-select v-model="storePromotion.mallClassify" placeholder="请输入商城分类!">
						<a-select-option :key="index" v-for="(item, index) in mallTypeList" :value="item.id">{{ item.name
						}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
					<a-button @click="last()">上一步，填写商品信息</a-button>
					<a-button style="margin-left: 20px;" type="primary" @click="onSubmit"
						:disabled="checkstorePromotion()">下一步，填写商品属性</a-button>
				</a-form-model-item>
			</a-form-model>

			<a-form-model v-if="current == 2" :model="commodityAttr" style="margin-top: 20px;" :label-col="{ span: 4 }"
				:wrapper-col="{ span: 14 }">
				<a-form-model-item>
					<div>
						<div style="color: red;width: 810px;
				margin-left: 170px;">
							注：图片比例1：1，图片大小不能超过2MB
						</div>
					</div>
				</a-form-model-item>
				<a-form-model-item label="商品主图" required>
					<el-upload list-type="picture-card" :action="domain" :data="QiniuData" :on-error="uploadError"
						:on-success="uploadSuccess" :before-upload="beforeStoreUpload" :limit="6" multiple
						:on-exceed="handleExceed" :file-list="bannerList">
						<i slot="default" class="el-icon-plus">
							<div style="font-size: 14px;">商品相册(6张)</div>
						</i>
						<div slot="file" slot-scope="{ file }">
							<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i
										class="el-icon-zoom-in"></i></span>
								<span v-if="false" class="el-upload-list__item-delete" @click="handleDownload(file)"><i
										class="el-icon-download"></i></span>
								<span v-if="!disabled" class="el-upload-list__item-delete" @click="bannerRemove(file)"><i
										class="el-icon-delete"></i></span>
							</span>
						</div>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>
				</a-form-model-item>

				<a-form-model-item>
					<div>
						<div style="color: red;width: 810px;
				margin-left: 170px;">
							注：图片长度尽量不要过长，图片大小不能超过2MB
						</div>
					</div>
				</a-form-model-item>

				<a-form-model-item label="商品详情" required>
					<el-upload list-type="picture-card" :action="domain" :data="QiniuData" :on-error="uploadError"
						:on-success="uploadSuccessUpload" :before-upload="beforeStoreDetailUpload" :limit="15" multiple
						:on-exceed="handleExceed" :file-list="storeDetailList">
						<i slot="default" class="el-icon-plus">
							<div style="font-size: 14px;">商品详情(15张)</div>
						</i>
						<div slot="file" slot-scope="{ file }">
							<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i
										class="el-icon-zoom-in"></i></span>
								<span v-if="false" class="el-upload-list__item-delete" @click="handleDownload(file)"><i
										class="el-icon-download"></i></span>
								<span v-if="!disabled" class="el-upload-list__item-delete"
									@click="bannerDetailRemove(file)"><i class="el-icon-delete"></i></span>
							</span>
						</div>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>
				</a-form-model-item>

				<a-form-model-item label="商品详情描述"><a-textarea v-model="storeInfo.detailDescribe"
						placeholder="请输入商品详情描述" /></a-form-model-item>

				<!-- <a-form-model-item>
					<div>
						<div
							style="color: red;width: 810px;
	margin-left: 170px;"
						>
							注：以下价格以“分”为单位；比如：输入市场价格：999，实际显示金额是9.99元；市场价格不能低于售价（售价为帝全会员价）！
						</div>
					</div>
				</a-form-model-item> -->

				<a-form-model ref="dynamicValidateForm" :model="dynamicValidateForm" v-bind="formItemLayoutWithOutLabel">
					<a-form-model-item v-for="(domain, index) in dynamicValidateForm.domains" :key="domain.key"
						v-bind="index === 0 ? formItemLayout : {}" :label="index === 0 ? '商品规格' : ''"
						:prop="'domains.' + index + '.value'" :rules="{
							required: true,
							message: '请输入商品规格',
							trigger: 'blur'
						}">
						<a-input :maxLength="150" v-model="domain.value" placeholder="请输入商品规格~(例如: 红色 尺寸40 大码)"
							style="width: 30%; margin-right: 8px" />
						库存：
						<a-input-number placeholder="库存" :max="9999999" :min="0" style=" margin-right: 8px"
							v-model="domain.ku" />
						市场价格(元)：
						<a-input-number placeholder="市场价格" :min="0.02" :max="9999999"
							style=" margin-right: 8px;width: 120px;" v-model="domain.bazaarPrice"
							@change="checkBazaarPrice(domain.bazaarPrice, domain.price, index)" :precision="2"
							:formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
							:parser="value => value.replace(/\￥\s?|(,*)/g, '')" />
						帝全售价(元)：
						<a-input-number placeholder="售价" :min="0.01" :precision="2"
							:formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
							:parser="value => value.replace(/\￥\s?|(,*)/g, '')" :max="Number(domain.bazaarPrice)"
							style=" margin-right: 8px;width: 120px;" v-model="domain.price"
							@change="checkPrice(domain.price, domain.bazaarPrice)" />
						<a-upload :action="domainIs" :data="QiniuData" :beforeUpload="beforeSpecificationPicUpload"
							listType="picture" :defaultFileList="domain.specificationPicList" @preview="handlePreview"
							:remove="specificationPicRemove" :showUploadList="{ showRemoveIcon: false }">
							<a-button v-if="domain.specificationPicList == undefined" @click="specificationPicClick(index)">
								<a-icon type="upload" />
								商品图片(1张)
							</a-button>

						</a-upload>
						<!-- 
						<el-upload
							v-if="domain.specificationPicList == undefined"
							class="upload-demo"
							:on-preview="handlePictureCardPreview"
							:on-remove="specificationPicRemove"
							:file-list="domain.specificationPicList"
							list-type="picture"
							:action="domainIs"
							:data="QiniuData"
							:on-error="uploadError"
							:before-upload="beforeSpecificationPicUpload"
							:limit="1"
							multiple
							:on-exceed="handleExceed"
						>
							<a-button v-if="domain.specificationPicList == undefined" @click="specificationPicClick(index)">
								<a-icon type="upload" />
								商品图片(1张)
							</a-button>
							 <el-button size="small" type="primary">点击上传</el-button>
							<div slot="tip" v-if="domain.specificationPicList == undefined" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
						</el-upload> -->
						<a-icon type="minus-circle-o" v-if="dynamicValidateForm.domains.length > 1"
							class="dynamic-delete-button" @click="removeDomain(domain)" />
					</a-form-model-item>
					<a-form-model-item v-bind="formItemLayoutWithOutLabel">
						<a-button type="dashed" style="width: 60%" @click="addDomain(false)">
							<a-icon type="plus" />
							添加商品规格
						</a-button>
					</a-form-model-item>

					<a-form-model-item v-bind="formItemLayoutWithOutLabel">
						<a-button @click="last()">上一步，填写商品信息</a-button>
						<a-button type="primary" style="margin-left: 20px;" html-type="submit"
							:disabled="checkstoreInfoAll()" @click="submitForm('dynamicValidateForm')">
							完成，提交商品
						</a-button>
						<a-popconfirm title="确定要重置所有信息吗 ?" @confirm="confirm" @cancel="cancel" okText="Yes" cancelText="No">
							<a-button style="margin-left: 20px">重置</a-button>
						</a-popconfirm>
					</a-form-model-item>
				</a-form-model>
			</a-form-model>
		</a-card>
	</div>
</template>

<script>
import api from '../../../api/Api.js';
import axios from 'axios';

export default {
	inject: ['reload'],
	data() {
		return {
			domain: 'https://upload-z2.qiniup.com', // 七牛云的上传地址（华南区）
			domainIs: 'https://upload-z2.qiniup.com', // 七牛云的上传地址（华南区）
			QiniuData: {
				key: '', //图片名字处理
				token: '' //七牛云token
			},
			bannerList: [],
			qiniuaddr: 'http://cdn.diqwl.com', // 七牛云的图片外链地址
			previewVisible: false,
			previewImage: '',
			pictureAddress: '',
			storeDetailList: [],
			storeInfo: {
				keyword: '',
				name: '',
				classify: '',
				subhead: '',
				productSort: 0,
				detailDescribe: ''
			},
			zero: 'process',
			one: 'wait',
			two: 'wait',
			zeroDisabled: false,
			oneDisabled: true,
			twoDisabled: true,
			current: 0,
			storePromotion: {
				serve: [],
				putaway: true,
				recommend: true,
				mallClassify: '',
				postage: true,
				onLinePay: false,
				minShop: 0,
				freight: 0,
				limit: false
			},
			commodityAttr: {},
			formItemLayout: {
				labelCol: {
					xs: { span: 24 },
					sm: { span: 4 }
				},
				wrapperCol: {
					xs: { span: 24 },
					sm: { span: 20 }
				}
			},
			formItemLayoutWithOutLabel: {
				wrapperCol: {
					xs: { span: 24, offset: 0 },
					sm: { span: 20, offset: 4 }
				}
			},
			dynamicValidateForm: {
				domains: []
			},
			typeList: [],
			mallTypeList: [],
			treeData: [],
			index: -1,
			okSubmit: false,
			dialogImageUrl: '',
			dialogVisible: false,
			disabled: false,
			adminPhone: localStorage.getItem('phone')
		};
	},
	mounted() {
		this.getQiniuToken();
		this.getInfoType();
		this.addDomain(true);
		this.getMallType();
	},
	methods: {
		submitForm(formName) {
			const that = this;
			this.$refs[formName].validate(valid => {
				if (valid) {
					const parm = {};
					const bannerList = [];
					const storeDetailList = [];
					that.bannerList.forEach((item, index, array) => {
						bannerList.push(item.url);
					});
					that.storeDetailList.forEach((item, index, array) => {
						storeDetailList.push(item.url);
					});

					parm.productPic = bannerList;
					parm.productDetailPic = storeDetailList;

					var obj = Object.assign(parm, that.storeInfo, that.storePromotion);
					const specification = [];
					console.log(that.dynamicValidateForm.domains);

					const specificationPicList = that.dynamicValidateForm.domains[this.index].specificationPicList;
					if (specificationPicList == undefined) {
						this.$message.error("请输入商品规格图片！")
						return;
					}
					that.dynamicValidateForm.domains.forEach((item, index, array) => {
						var temp = {};
						temp.specification = item.value;
						temp.ku = item.ku;
						temp.price = item.price * 100;
						temp.bazaarPrice = item.bazaarPrice * 100;
						temp.specificationPic = item.specificationPicList[0].url;
						specification.push(temp);
					});

					obj.specification = specification;
					obj.postage = that.booltoNumber(obj.postage);
					obj.putAway = that.booltoNumber(obj.putaway);
					obj.recommend = that.booltoNumber(obj.recommend);
					obj.onLinePay = that.booltoNumber(obj.onLinePay);
					obj.limit = that.booltoNumber(obj.limit)

					console.log(obj);

					that.addCommodity(obj);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		checkBazaarPrice(bazzPrice, price, index) {
			this.dynamicValidateForm.domains[index].price = bazzPrice * 0.98;
		},
		checkPrice(price, bazzPrice) {
			if (bazzPrice == undefined) {
				this.$message.error('请填入市场价格！');
				this.okSubmit = false;
				return;
			}
			if (price > bazzPrice * 0.98) {
				this.$message.error('会员价应低于市场价的98折！');
				this.okSubmit = false;
				return;
			}
			this.okSubmit = true;
		},
		confirm(e) {
			this.resetForm();
		},
		cancel(e) {
			console.log(e);
		},
		resetForm() {
			this.storeInfo.maxShop = 0;
			this.storeInfo.minShop = 0;
			this.storeInfo.name = '';
			this.storeInfo.classify = '';
			this.storeInfo.subhead = '';
			this.storeInfo.productSort = 0;
			this.storeInfo.keyword = '';
			this.storeInfo.detailDescribe = '';
			this.storePromotion.mallClassify = '';
			this.bannerList = [];
			this.storeDetailList = [];
			this.$refs['dynamicValidateForm'].resetFields();
			this.dynamicValidateForm.domains = [];
			this.one = 'wait';
			this.two = 'wait';
			this.oneDisabled = true;
			this.twoDisabled = true;
			this.current = 0;
			this.addDomain(true);
		},
		specificationPicClick(index) {
			this.index = index;
		},
		addCommodity(pram) {
			const that = this;
			let url = 'api/store/v1/admin/commodity/addCommodity';
			let parm = pram;

			api.postRequest(url, parm, res => {
				if (res.data.status == 200) {
					this.$message.success('添加成功！');
					that.resetForm();
				} else {
					console.log(res);
					this.$message.error(res.data.message);
				}
			});
		},
		booltoNumber(bool) {
			if (bool) {
				return 1;
			} else {
				return 0;
			}
		},
		handleCancel() {
			this.previewVisible = false;
		},
		specificationPicRemove(file) {
			this.dynamicValidateForm.domains[this.index].specificationPicList = [];
			console.log("删除");
			// const specificationPicList = this.dynamicValidateForm.domains[this.index].specificationPicList;
			// var index = specificationPicList.findIndex(item => {
			// 	if (item.uid == file.uid) {
			// 		return true;
			// 	}
			// });
			// specificationPicList.splice(index, 1);
		},
		bannerRemove(file) {
			var index = this.bannerList.findIndex(item => {
				if (item.uid == file.uid) {
					return true;
				}
			});
			this.bannerList.splice(index, 1);
		},
		bannerDetailRemove(file) {
			var index = this.storeDetailList.findIndex(item => {
				if (item.uid == file.uid) {
					return true;
				}
			});
			this.storeDetailList.splice(index, 1);
		},
		handlePreview(file) {
			this.previewImage = file.url || file.thumbUrl;
			this.previewVisible = true;
		},
		beforeSpecificationPicUpload(file) {
			const isPNG = file.type === 'image/png';
			const isJPEG = file.type === 'image/jpeg';
			const isJPG = file.type === 'image/jpg';
			const isLt2M = file.size / 1024 / 1024 < 2;

			if (!isPNG && !isJPEG && !isJPG) {
				this.$message.error('上传图片只能是 jpg、png、jpeg 格式!');
				return false;
			}
			if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 2MB!');
				return false;
			}
			this.QiniuData.key = localStorage.getItem('accessToken') + Date.parse(new Date());
			this.pictureAddress = this.qiniuaddr + '/' + this.QiniuData.key;

			var obj = {
				status: 'done'
			};
			obj.uid = file.uid;
			obj.name = this.QiniuData.key;
			obj.url = this.pictureAddress;
			obj.thumbUrl = this.pictureAddress;
			obj.status = 'done';

			if (this.dynamicValidateForm.domains[this.index].specificationPicList == undefined) {
				this.dynamicValidateForm.domains[this.index].specificationPicList = [];
			}

			if (this.dynamicValidateForm.domains[this.index].specificationPicList.length > 0) {
				return false;
			}

			let temp = this.dynamicValidateForm;
			this.dynamicValidateForm = [];
			this.dynamicValidateForm = temp;

			console.log(obj.url);

			this.dynamicValidateForm.domains[this.index].specificationPicList.push(obj);
		},
		beforeStoreUpload(file) {
			const isPNG = file.type === 'image/png';
			const isJPEG = file.type === 'image/jpeg';
			const isJPG = file.type === 'image/jpg';
			const isLt2M = file.size / 1024 / 1024 < 2;

			if (!isPNG && !isJPEG && !isJPG) {
				this.$message.error('上传图片只能是 jpg、png、jpeg 格式!');
				return false;
			}
			if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 2MB!');
				return false;
			}
			this.QiniuData.key = localStorage.getItem('accessToken') + Date.parse(new Date());
			this.pictureAddress = this.qiniuaddr + '/' + this.QiniuData.key;
		},
		beforeStoreDetailUpload(file) {
			const isPNG = file.type === 'image/png';
			const isJPEG = file.type === 'image/jpeg';
			const isJPG = file.type === 'image/jpg';
			const isLt2M = file.size / 1024 / 1024 < 2;

			if (!isPNG && !isJPEG && !isJPG) {
				this.$message.error('上传图片只能是 jpg、png、jpeg 格式!');
				return false;
			}
			if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 2MB!');
				return false;
			}
			this.QiniuData.key = localStorage.getItem('accessToken') + Date.parse(new Date());
			this.pictureAddress = this.qiniuaddr + '/' + this.QiniuData.key;
		},
		getMallType() {
			const that = this;
			let url = 'api/store/v1/admin/mall/list/withChildren';
			let parm = '1';

			api.postRequest(url, parm, res => {
				if (res.status == 200) {
					that.mallTypeList = res.data.data;
					var obj = {
						id: 2,
						name: "数码电子"
					}
					that.mallTypeList.splice(0, 0, obj);

					// that.mallTypeList.shift();
					that.mallTypeList.pop()
					console.log(that.mallTypeList);
				} else {
					this.$message.waring(res.message);
				}
			});
		},
		getInfoType() {
			const that = this;
			let url = 'api/store/v1/admin/commodity/typeList';
			let parm = {
				parentId: 0
			};

			api.postRequest(url, parm, res => {
				if (res.status == 200) {
					that.typeList = res.data.data;
				} else {
					this.$message.waring(res.message);
				}
			});
		},
		onSubmit() {
			this.current++;
			console.log('商品信息!', this.storeInfo, this.current);
			console.log('商品促销!', this.storePromotion, this.current);
		},
		checkstoreInfoAll() {
			if (this.checkStoreInfo() || this.checkstorePromotion()) {
				return true;
			}
			if (this.bannerList.length == 0 || this.storeDetailList.length == 0) {
				return true;
			}
			return false;
		},
		checkStoreInfo() {
			var form = this.storeInfo;
			if (form.name == '' || form.classify == '') {
				this.oneDisabled = true;
				this.one = 'wait';
				return true;
			} else {
				this.oneDisabled = false;
				this.one = 'process';
				return false;
			}
		},

		checkstorePromotion() {
			var form = this.storePromotion;
			//console.log(form.keyword)
			if (form.recommend == false) {
				this.twoDisabled = false;
				this.two = 'process';
				return false;
			} else if (form.recommend == true && form.mallClassify != '') {
				this.twoDisabled = false;
				this.two = 'process';
				return false;
			} else {
				this.twoDisabled = true;
				this.two = 'wait';
				return true;
			}
		},
		last() {
			this.current--;
		},
		step(current) {
			console.log(this.current);
		},
		removeDomain(item) {
			let index = this.dynamicValidateForm.domains.indexOf(item);
			if (index !== -1) {
				this.dynamicValidateForm.domains.splice(index, 1);
			}
			this.index = this.index - 1;
		},
		addDomain(bool) {
			if (!bool) {
				if (this.dynamicValidateForm.domains[this.index].specificationPicList == undefined) {
					this.$message.error("请完善商品规格信息！")
					return;
				}
			}
			this.index = this.index + 1;
			this.dynamicValidateForm.domains.push({
				value: '',
				key: Date.now()
			});

		},
		//请求后台拿七牛云token
		getQiniuToken() {
			const that = this;
			let url = 'api/file/v1/qiniu/getToken';
			let parm = 1;

			api.postRequest(url, parm, res => {
				if (res.data.status == 200) {
					this.QiniuData.token = res.data.data.token;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		uploadSuccess(response, file, fileList) {
			this.uploadPicUrl = `${this.qiniuaddr}/${response.key}`;
			var obj = {
				status: 'done'
			};
			obj.uid = file.uid;
			obj.name = this.QiniuData.key;
			obj.url = this.pictureAddress;
			this.bannerList.push(obj);
		},
		uploadSuccessUpload(response, file, fileList) {
			this.uploadPicUrl = `${this.qiniuaddr}/${response.key}`;
			var obj = {
				status: 'done'
			};
			obj.uid = file.uid;
			obj.name = this.QiniuData.key;
			obj.url = this.pictureAddress;
			this.storeDetailList.push(obj);
		},
		uploadError(err, file, fileList) {
			this.$message.error("上传出错，请重试!");
		},
		handleExceed(files, fileList) {
			this.$message.warning(`图片选择已上限，如需更换，请删除上一张图片在重新选择！`);
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
	}
};
</script>
<style>
.el-icon-close {
	display: none;
}

#components-form-demo-validate-other .dropbox {
	height: 180px;
	line-height: 1.5;
}

.el-upload__input {
	display: none;
}

.ant-form input[type='file'] {
	display: none;
}

.ant-select-tree-title {
	color: #000000;
}

.dynamic-delete-button {
	cursor: pointer;
	position: relative;
	top: 4px;
	font-size: 24px;
	color: #999;
	transition: all 0.3s;
}

.dynamic-delete-button:hover {
	color: #777;
}

.dynamic-delete-button[disabled] {
	cursor: not-allowed;
	opacity: 0.5;
}

/* tile uploaded pictures */
.upload-list-inline>>>.ant-upload-list-item {
	float: left;
	width: 200px;
	margin-right: 8px;
}

.upload-list-inline>>>.ant-upload-animate-enter {
	animation-name: uploadAnimateInlineIn;
}

.upload-list-inline>>>.ant-upload-animate-leave {
	animation-name: uploadAnimateInlineOut;
}
</style>
